import {useFieldContext} from '../../integrations/form/index.js'
import {Field} from '@chakra-ui/react'
import {motion} from 'motion/react'
import {ReactNode} from 'react'

const _FieldRoot = motion.create(Field.Root)

export function FieldRoot(props: {children: ReactNode; required?: boolean; disabled?: boolean}) {
  const field = useFieldContext<unknown>()

  const isInvalid = field.state.meta.errors.length > 0
  const isDirty = field.state.meta.isDirty

  return (
    <_FieldRoot invalid={isInvalid} disabled={props.disabled} data-field-dirty={isDirty ? 'true' : undefined}>
      {props.children}
    </_FieldRoot>
  )
}
